import { useMemo } from 'react'
import { Form as FinalForm } from 'react-final-form'
import { Button, Grid, makeStyles } from '@material-ui/core'
import useTranslate from '../../../i18n/useTranslate'
import MyTextfield from '../../../control/textfield/textfield'
import MySelect from '../../../control/select/select'
import { ClosedByTermKeyword } from '../../../services/um/useSearchClosedByTerm'

type ClosePanelComponentProps = {
    onSubmit: (value: ClosedByTermKeyword) => void
    initialValue: ClosedByTermKeyword
    onClear: (form: any) => void
}

const closedDueYears = [3, 4, 5]

const Panel = ({ onSubmit, initialValue, onClear }: ClosePanelComponentProps) => {
    const classes = useStyles()
    const translate = useTranslate()
    let defaultTermYear = initialValue.termYear ? [initialValue.termYear] : undefined

    const closedDueList = useMemo(
        () =>
            closedDueYears.map((year) => ({
                value: year,
                label: translate.get('UM.CLOSED_DUE.YEAR_LABEL', [`${year}`]),
            })),
        [translate.languageStore.currentLanguage],
    )

    return (
        <Grid className={classes.root}>
            <FinalForm onSubmit={onSubmit} initialValues={initialValue}>
                {({ handleSubmit, form, values }) => {
                    return (
                        <Grid container spacing={2} className={classes.container}>
                            <Grid item xs={12} sm={6}>
                                <MyTextfield
                                    name="keyword"
                                    materialInputProps={{
                                        disabled: false,
                                        label: translate.get('UM.CLOSED_DUE.KEYWORD.LABEL'),
                                        placeholder: translate.get('UM.CLOSED_DUE.KEYWORD.PLACEHOLDER'),
                                        size: 'small',
                                    }}
                                />
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <MySelect
                                    name="termYear"
                                    label={translate.get('UM.CLOSED_DUE.SELECT_CLOSED_DUE.LABEL')}
                                    option={closedDueList}
                                    size="small"
                                    placeholder={translate.get('UM.CLOSED_DUE.SELECT_CLOSED_DUE.PLACEHOLDER')}
                                    defaultValue={defaultTermYear}
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <Grid container justify="flex-end" spacing={2}>
                                    <Grid item>
                                        <Button
                                            size={'large'}
                                            fullWidth
                                            variant="contained"
                                            color="default"
                                            onClick={() => onClear(form)}
                                        >
                                            {translate.get('BUTTON.RESET')}
                                        </Button>
                                    </Grid>
                                    <Grid item>
                                        <Button
                                            size={'large'}
                                            fullWidth
                                            variant="contained"
                                            color="primary"
                                            onClick={handleSubmit}
                                        >
                                            {translate.get('BUTTON.SEARCH')}
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    )
                }}
            </FinalForm>
        </Grid>
    )
}

const useStyles = makeStyles(() => ({
    container: {
        padding: '1.7rem',
    },
    root: {
        width: '100%',
    },
}))

export default Panel
